// extracted by mini-css-extract-plugin
export default {"card":"CardArticle_card__6ZaVq","date":"CardArticle_date__ljIyp","box_content":"CardArticle_box_content__ifsW8","btn":"CardArticle_btn__9BD6o"};